/* AagamStuti Hindi search. Plain JavaScript, no libraries. Linked by the header section, after aagamstuti-search.js.
   Shopify search only knows the English words in the product titles. When a shopper types Hindi (Devanagari), the words are
   swapped for the English ones from Theme settings > Shopping > Hindi search words before the search is sent.
   The shopper keeps seeing the Hindi they typed: the search page shows it in the heading and says what it searched for.
   Words that are not in the list are left alone, so Shopify still does its own best guess for them. */
(function () {
  'use strict';
  if (window.__asHindiBoot) return;
  window.__asHindiBoot = true;

  var doc = document;
  var holder = doc.getElementById('as-hindi-map');
  if (!holder) return;
  var DEV = /[ऀ-ॿ]/;
  var map = null;

  /* Hindi is spelled in several ways (दीया, दिया; मंदिर, मन्दिर; माँ, मां). Fold the common ones so both sides compare equal. */
  function fold(s) {
    s = String(s || '');
    try { s = s.normalize('NFC'); } catch (e) {}
    return s
      .replace(/[​-‍﻿]/g, '')
      .replace(/ँ/g, 'ं')
      .replace(/़/g, '')
      .replace(/[ङञणनम]्(?=[क-ह])/g, 'ं')
      .replace(/ि/g, 'ी').replace(/ु/g, 'ू')
      .replace(/इ/g, 'ई').replace(/उ/g, 'ऊ')
      .replace(/ॅ/g, 'े').replace(/ॉ/g, 'ो')
      .replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function build() {
    if (map) return map;
    map = {};
    var text = '';
    try { text = JSON.parse(holder.textContent); } catch (e) { text = ''; }
    String(text || '').split(/\r?\n/).forEach(function (line) {
      var at = line.indexOf('=');
      if (at < 0) return;
      var english = line.slice(at + 1).trim().toLowerCase();
      line.slice(0, at).split(',').forEach(function (word) {
        var key = fold(word);
        if (key) map[key] = english;
      });
    });
    return map;
  }

  /* Hindi in, English out. Up to three words are tried together first (राम दरबार), then one at a time.
     An empty English side means "leave this word out" (जी, की, के). Nothing changes unless at least one real word matched. */
  function translate(q) {
    q = String(q || '').trim();
    if (!q || !DEV.test(q)) return q;
    var dict = build(), words = q.split(/\s+/), out = [], hit = false, i = 0, n, key, found;
    while (i < words.length) {
      found = false;
      for (n = Math.min(3, words.length - i); n >= 1 && !found; n--) {
        key = fold(words.slice(i, i + n).join(' '));
        if (Object.prototype.hasOwnProperty.call(dict, key)) {
          if (dict[key]) { out.push(dict[key]); hit = true; }
          i += n; found = true;
        }
      }
      if (!found) { out.push(words[i]); i++; }
    }
    return hit ? out.join(' ').replace(/\s+/g, ' ').trim() : q;
  }
  window.asHindi = { translate: translate };

  /* ---------- Suggestions: send the English words to Shopify ---------- */
  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function (input, init) {
      if (typeof input === 'string' && input.indexOf('/search/suggest') !== -1) {
        var m = input.match(/([?&])q=([^&]*)/), typed = null;
        if (m) { try { typed = decodeURIComponent(m[2].replace(/\+/g, ' ')); } catch (e) { typed = null; } }
        if (typed && DEV.test(typed)) {
          var eng = translate(typed);
          if (eng !== typed) input = input.replace(m[0], m[1] + 'q=' + encodeURIComponent(eng));
        }
      }
      return origFetch.call(this, input, init);
    };
  }

  /* The suggestion panel talks about “what you searched for”: show the Hindi the shopper typed, and keep it on the "See all" link */
  var results = doc.querySelector('[data-search-results]');
  var input = doc.querySelector('[data-search-input]');
  if (results && input && 'MutationObserver' in window) {
    new MutationObserver(function () {
      var typed = input.value.trim();
      if (!typed || !DEV.test(typed) || translate(typed) === typed) return;
      Array.prototype.forEach.call(results.querySelectorAll('[data-term-echo]'), function (el) {
        if (el.textContent !== typed) { el.textContent = typed; el.setAttribute('lang', 'hi'); }
      });
      var all = results.querySelector('.as-sug__all a');
      if (all && all.getAttribute('href').indexOf('hq=') === -1) all.setAttribute('href', all.getAttribute('href') + '&hq=' + encodeURIComponent(typed));
    }).observe(results, { childList: true, subtree: true });
  }

  /* ---------- Search forms: capture phase, after the recent-searches script has saved what was typed ---------- */
  doc.addEventListener('submit', function (e) {
    var form = e.target.closest ? e.target.closest('form[role="search"]') : null;
    if (!form) return;
    var q = form.querySelector('input[name="q"]');
    if (!q) return;
    var old = form.querySelector('input[name="hq"]');
    if (old) old.parentNode.removeChild(old);
    var typed = q.value.trim(), eng = translate(typed);
    if (eng === typed) return;
    var keep = doc.createElement('input');
    keep.type = 'hidden'; keep.name = 'hq'; keep.value = typed;
    form.appendChild(keep);
    q.value = eng;
    setTimeout(function () { q.value = typed; }, 0);
  }, true);

  /* ---------- The search page ---------- */
  var path = location.pathname.replace(/\/+$/, '');
  if (path.slice(-7) !== '/search') return;
  var params = new URLSearchParams(location.search), qs = params.get('q') || '', hq = params.get('hq') || '';

  /* Someone opened /search?q=गणेश directly (a shared link, a Google result): search again with the English words */
  if (qs && !hq && DEV.test(qs)) {
    var eng = translate(qs);
    if (eng !== qs) {
      params.set('q', eng); params.set('hq', qs);
      location.replace(location.pathname + '?' + params.toString());
      return;
    }
  }
  if (!hq || !qs) return;

  function decorate() {
    var box = doc.querySelector('[data-collection-section]') || doc;
    var h1 = box.querySelector('h1');
    if (h1) {
      var m = h1.textContent.match(/^(.*?)“[^”]*”(.*)$/);
      if (m) {
        h1.textContent = m[1] + '“';
        var term = doc.createElement('span');
        term.className = 'as-sacred'; term.setAttribute('lang', 'hi'); term.textContent = hq;
        h1.appendChild(term);
        h1.appendChild(doc.createTextNode('”' + m[2]));
      }
    }
    var field = doc.getElementById('search-page-q');
    if (field) {
      field.value = hq;
      var form = field.closest('form');
      if (form && !form.querySelector('[data-hindi-note]')) {
        var note = doc.createElement('p');
        note.className = 'as-fine';
        note.setAttribute('data-hindi-note', '');
        note.style.marginTop = 'var(--space-3)';
        note.textContent = 'Showing results for “' + qs + '”.';
        form.parentNode.insertBefore(note, form.nextSibling);
      }
    }
    /* Keep the Hindi words on filter and sort changes */
    var filters = doc.querySelector('form[data-filters-form]');
    if (filters && !filters.querySelector('input[name="hq"]')) {
      var keep = doc.createElement('input');
      keep.type = 'hidden'; keep.name = 'hq'; keep.value = hq;
      filters.appendChild(keep);
    }
    /* "Also try" already offers the Hindi spelling, which is what they typed */
    var nav = doc.querySelector('.as-alsotry');
    if (nav) {
      Array.prototype.forEach.call(nav.querySelectorAll('[lang="hi"]'), function (a) { a.parentNode.removeChild(a); });
      if (!nav.querySelector('a')) nav.parentNode.removeChild(nav);
    }
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', decorate); else decorate();
})();
